var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        { attrs: { data: _vm.data, "empty-text": _vm.emptyData } },
        [
          _c("el-table-column", {
            attrs: { prop: "chave", label: _vm.colunaChave }
          }),
          _c("el-table-column", {
            attrs: { prop: "quantidade", label: "Quantidade" }
          })
        ],
        1
      ),
      _c("el-row", [
        _c("h4", [
          _vm._v("Total: " + _vm._s(_vm.totalDeConversas) + " conversas")
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1e615667", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e615667","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios_ouvidoria/components/AppListagemConversas.vue
// module id = null
// module chunks = 